export default {
    targetSetSchoolYear: {
        defaults: {
            rootProperty: 'school_years',
            endpoint: 'targetSetV.php' // scope: target_set_id=14
        },
        read: {
            params: {
                action: 'get',
                property: 'school_years'
            }
        },
        create: {
            params: {
                action: 'create',
                property: 'school_years'
            }
        },
        update: {
            params: {
                action: 'update',
                property: 'school_years'
            }
        },
        destroy: {
            params: {
                action: 'delete',
                property: 'school_years'
            }
        }
    }
}